import { Rotation } from '../../entities/Transform/Rotation';
import { Engine } from '../../core/Engine';
import { RotateCommand } from '../Commands';
import { Image } from '../../entities/Drawable/Image';

export class RotateCommandHandler {
    private engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: RotateCommand): void {
        const obj = this.engine.find(command.uuid);

        if (!obj || obj.isLocked) {
            return;
        }

        const angle = Rotation.convertFromDegreeToRad(command.angle);
        obj.transform.rotate(angle);

        // Gestion ClipPath rotation si c'est une Image avec clipPath
        if (obj instanceof Image && obj.clipPath) {
            obj.clipPath.transform.rotate(angle);
        }
    }
}
